import React from 'react'
import { FaBullhorn } from "react-icons/fa";
import { Link } from 'react-router-dom';


import Spamkeyword from '../pages/images/chatbotbuilder.png'
import SystemReport from '../pages/images/whatsappflow.png'
import deliverymis from '../pages/images/qrcode.png'
import TTS from '../pages/images/widgetImage.png'
import bulkUpload from '../pages/images/bulkUpload.png'
import unsubscibe from '../pages/images/sms-total (1).png'



const ReportingTools = [
    {
        title: "Chatbot Builder",
        description: "Build chatbots to automate conversations.",
        slug: "/WAMessage/WAChatbotFlow/Index",
        image: Spamkeyword
    },
    {
        title: "WhatsApp Flows",
        description: "Design and control WhatsApp Flows.",
        slug: "/WAMessage/WAFlow/Index",
        image: SystemReport
    },
    {
        title: "QR Codes",
        description: "Design and control WhatsApp QR Codes.",
        slug: "/WAMessage/WAQRCodes",
        image: deliverymis
    },
    {
        title: "WhatsApp Widget",
        description: "Design and control WhatsApp Widget.",
        slug: "/WAMessage/WAWidgets",
        image: TTS
    }
];
const ContactManager = [
    {
        title: "Email Provider",
        description: "Build chatbots to automate conversations.",
        slug: "/Client/EmailProvider",
        image: unsubscibe
    }
];

function Automation() {
    return (
        <>
            <div className='pl-6 dark:bg-[#121519] w-[100%]'>
                <div className='border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md  dark:bg-[#121519] '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'> Automation</span>
                        </div>
                    </div>
                    <div className='w-[100%] flex gap-4 flex-wrap  items-center pt-3 pb-5 '>
                        {ReportingTools.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
        w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
        h-[160px] cursor-pointer text-center 
        [transform-style:preserve-3d] transition-all duration-300 ease-in-out 
        shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
        hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
        flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2'>{item.description}</span>
                                </Link>

                            </div>

                        ))
                        }

                    </div>
                    <div>

                    </div>
                </div>
                <div className='border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md  dark:bg-[#121519] mt-6 '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'>  Automation Config
                            </span>
                        </div>
                    </div>
                    <div className='w-[100%] flex gap-4 flex-wrap  items-center pt-3 pb-5 '>
                        {ContactManager.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
        w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
        h-[160px] cursor-pointer text-center 
        [transform-style:preserve-3d] transition-all duration-300 ease-in-out 
        shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
        hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
        flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2'>{item.description}</span>
                                </Link>

                            </div>

                        ))
                        }

                    </div>
                    <div>

                    </div>
                </div>

            </div >
        </>
    )
}

export default Automation